import { useState } from "react";
import "./gallery.css";

function getGalleryImages(setImage: React.Dispatch<React.SetStateAction<number>>) {
  const images = [];

  for (let i = 1; i <= 32; i++) {
    console.log(`./../../assets/images/gallery/${i}.png`);
    images.push(
        <img className="galleryItem" src={require(`./../../assets/images/gallery/${String(i).padStart(2, '0')}.png`)} alt="" onClick={() => {
            setImage(i);
        }}/>
    );
}

  return <div className="gallery">{images}</div>;
}

const Gallery = () => {
    const [image, setImage] = useState(1);

    return (
        <div className="galleryMain">
            <img className="gallerySelected" src={require(`./../../assets/images/gallery/${String(image).padStart(2, '0')}.png`)} alt="" />
            <div className="galleryScroll">
                {getGalleryImages(setImage)}
            </div>
        </div>
    )
}

export default Gallery;